"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import DropListItemRateGiveChangeButton from "./DropListItemRateGiveChangeButton";
import DropListItemRateGiveSubmit from "./DropListItemRateGiveSubmit";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { Time } from "@/helpers/time";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { Tooltip } from "react-tooltip";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
export enum RateChangeType {
  INCREASE = "INCREASE",
  DECREASE = "DECREASE",
}
export default function DropListItemRateGive(t0) {
  const $ = _c(58);
  const {
    drop,
    onRated,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [-69420, -42069, -6529, -420, -69, 69, 420, 6529, 42069, 69420];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const memeticValues = t2;
  const {
    canVote
  } = useDropInteractionRules(drop);
  const [onProgressRate, setOnProgressRate] = useState(1);
  const maxRating = drop.context_profile_context?.max_rating ?? 0;
  const minRating = drop.context_profile_context?.min_rating ?? 0;
  let t3;
  if ($[1] !== canVote || $[2] !== maxRating || $[3] !== minRating || $[4] !== onProgressRate) {
    t3 = () => {
      if (!canVote) {
        setOnProgressRate(0);
        return;
      }
      if (Math.abs(onProgressRate) > maxRating) {
        setOnProgressRate(onProgressRate > 0 ? maxRating : minRating);
        return;
      }
      setOnProgressRate(1);
    };
    $[1] = canVote;
    $[2] = maxRating;
    $[3] = minRating;
    $[4] = onProgressRate;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== canVote || $[7] !== drop) {
    t4 = [canVote, drop];
    $[6] = canVote;
    $[7] = drop;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== onRated) {
    t5 = () => {
      setOnProgressRate(1);
      onRated?.();
    };
    $[9] = onRated;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onSuccessfulRateChange = t5;
  const timeoutRef = useRef(null);
  const getIncreaseAmount = _temp;
  let t6;
  if ($[11] !== maxRating || $[12] !== minRating) {
    t6 = newValue => {
      if (newValue > maxRating) {
        return maxRating;
      }
      if (newValue < minRating) {
        return minRating;
      }
      return newValue;
    };
    $[11] = maxRating;
    $[12] = minRating;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const getCorrectedNewRate = t6;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = t8 => {
      const {
        previousRate,
        newRate,
        changeType
      } = t8;
      let finalVal = newRate;
      const values = changeType === RateChangeType.DECREASE ? memeticValues.toReversed() : memeticValues;
      for (const memeticVal of values) {
        if (previousRate < memeticVal && memeticVal < newRate || newRate < memeticVal && memeticVal < previousRate) {
          finalVal = memeticVal;
          break;
        }
      }
      return {
        rate: finalVal,
        isMemetic: values.includes(finalVal)
      };
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const getMemeticNewRate = t7;
  let modifyRate;
  if ($[15] !== getCorrectedNewRate) {
    const getNewRateConfig = t8 => {
      const {
        changeType: changeType_0,
        previousRate: previousRate_0,
        startTime: startTime_0
      } = t8;
      const increaseAmount = getIncreaseAmount(startTime_0);
      const newRate_0 = changeType_0 === RateChangeType.INCREASE ? previousRate_0 + increaseAmount : previousRate_0 - increaseAmount;
      const newValue_0 = Math.round(newRate_0 / increaseAmount) * increaseAmount;
      const correctedNewRate = getCorrectedNewRate(newValue_0);
      return {
        rate: correctedNewRate
      };
    };
    modifyRate = t9 => {
      const {
        changeType: changeType_1,
        intervalTime,
        previousRate: previousRate_1,
        startTime: startTime_1
      } = t9;
      const {
        rate: newRate_1
      } = getNewRateConfig({
        changeType: changeType_1,
        previousRate: previousRate_1,
        startTime: startTime_1
      });
      const {
        rate: memeticRate,
        isMemetic
      } = getMemeticNewRate({
        previousRate: previousRate_1,
        newRate: newRate_1,
        changeType: changeType_1
      });
      setOnProgressRate(memeticRate);
      const newIntervalTime = Math.max(10, intervalTime * 0.9);
      const waitForMemetic = isMemetic ? 1000 : newIntervalTime;
      timeoutRef.current = setTimeout(() => modifyRate({
        intervalTime: isMemetic && newIntervalTime < 300 ? 300 : newIntervalTime,
        changeType: changeType_1,
        previousRate: memeticRate,
        startTime: isMemetic ? startTime_1 + 1000 : startTime_1
      }), waitForMemetic);
    };
    $[15] = getCorrectedNewRate;
    $[16] = modifyRate;
  } else {
    modifyRate = $[16];
  }
  let t8;
  if ($[17] !== modifyRate || $[18] !== onProgressRate) {
    t8 = changeType_2 => {
      modifyRate({
        intervalTime: 500,
        changeType: changeType_2,
        previousRate: onProgressRate,
        startTime: Time.now().toMillis()
      });
    };
    $[17] = modifyRate;
    $[18] = onProgressRate;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const handleMouseDown = t8;
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const handleMouseUp = t9;
  let t10;
  if ($[21] !== onProgressRate) {
    t10 = () => `${onProgressRate > 0 ? "+" : ""}${formatNumberWithCommas(onProgressRate)}`;
    $[21] = onProgressRate;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const getRateText = t10;
  let t11;
  if ($[23] !== canVote || $[24] !== onProgressRate) {
    t11 = () => canVote && onProgressRate !== 0 && onProgressRate !== 1;
    $[23] = canVote;
    $[24] = onProgressRate;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const getShowRate = t11;
  let t12;
  if ($[26] !== onProgressRate) {
    t12 = () => {
      if (onProgressRate > 0) {
        return "tw-text-green";
      }
      if (onProgressRate < 0) {
        return "tw-text-red";
      }
      return "tw-text-iron-500";
    };
    $[26] = onProgressRate;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const getRateClasses = t12;
  const tooltipId = `rate-give-tooltip-${drop.id}`;
  const t13 = getShowRate() ? tooltipId : undefined;
  const t14 = `${isMobile ? "tw-gap-x-4" : ""} tw-w-full tw-inline-flex tw-items-center tw-gap-x-1`;
  let t15;
  if ($[28] !== canVote || $[29] !== handleMouseDown || $[30] !== isMobile) {
    t15 = <DropListItemRateGiveChangeButton canVote={canVote} type={RateChangeType.DECREASE} handleMouseDown={handleMouseDown} handleMouseUp={handleMouseUp} isMobile={isMobile} />;
    $[28] = canVote;
    $[29] = handleMouseDown;
    $[30] = isMobile;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== canVote || $[33] !== drop || $[34] !== isMobile || $[35] !== onProgressRate || $[36] !== onSuccessfulRateChange) {
    t16 = <DropListItemRateGiveSubmit rate={onProgressRate} drop={drop} canVote={canVote} onSuccessfulRateChange={onSuccessfulRateChange} isMobile={isMobile} />;
    $[32] = canVote;
    $[33] = drop;
    $[34] = isMobile;
    $[35] = onProgressRate;
    $[36] = onSuccessfulRateChange;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== canVote || $[39] !== handleMouseDown || $[40] !== isMobile) {
    t17 = <DropListItemRateGiveChangeButton canVote={canVote} type={RateChangeType.INCREASE} handleMouseDown={handleMouseDown} handleMouseUp={handleMouseUp} isMobile={isMobile} />;
    $[38] = canVote;
    $[39] = handleMouseDown;
    $[40] = isMobile;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t14 || $[43] !== t15 || $[44] !== t16 || $[45] !== t17) {
    t18 = <div className={t14}>{t15}{t16}{t17}</div>;
    $[42] = t14;
    $[43] = t15;
    $[44] = t16;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t13 || $[48] !== t18) {
    t19 = <div className="tw-relative tw-gap-y-1 tw-flex tw-flex-col tw-items-center" data-tooltip-id={t13}>{t18}</div>;
    $[47] = t13;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== getRateClasses || $[51] !== getRateText || $[52] !== getShowRate || $[53] !== tooltipId) {
    t20 = getShowRate() && <Tooltip id={tooltipId} place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}><div className="tw-text-center"><span className={`${getRateClasses()} tw-text-xs tw-font-normal tw-text-center tw-w-full tw-transition tw-duration-300 tw-ease-out`}>{getRateText()}</span></div></Tooltip>;
    $[50] = getRateClasses;
    $[51] = getRateText;
    $[52] = getShowRate;
    $[53] = tooltipId;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== t19 || $[56] !== t20) {
    t21 = <>{t19}{t20}</>;
    $[55] = t19;
    $[56] = t20;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  return t21;
}
function _temp(startTime) {
  const elapsedSeconds = (Time.now().toMillis() - startTime) / 1000;
  if (elapsedSeconds < 2) {
    return 1;
  }
  if (elapsedSeconds < 4) {
    return 10;
  }
  if (elapsedSeconds < 6) {
    return 100;
  }
  return 1000;
}